import { useCallback, useContext, useState } from 'react'

import { getAllNotification, getNotificationCount, updateNotification } from '@/apis/notifications'
import { NotificationContext } from '@/contexts/Notification.context'
import { GetAllNotificationResponse } from '@/types/apis/notifications/GetAllNotificationResponse'
import { UpdateNotificationRequest } from '@/types/apis/notifications/UpdateNotificationRequest'
import { UpdateNotificationResponse } from '@/types/apis/notifications/UpdateNotificationResponse'

export const useNotifications = () => {
  const [getNotificationsLoading, setGetNotificationsLoading] = useState(false)
  const [getNotificationsResponse, setNotificationsResponse] = useState<GetAllNotificationResponse>()
  const [updateNotificationLoading, setUpdateNotificationLoading] = useState(false)
  const [updateNotificationResponse, setUpdateNotificationResponse] = useState<UpdateNotificationResponse>()
  const [getNotificationCountLoading, setGetNotificationCountLoading] = useState(false)
  const [getNotificationCountResponse, setGetNotificationCountResponse] = useState<number>()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [count, setNotificationCount] = useContext(NotificationContext)

  const get = useCallback(async () => {
    try {
      setGetNotificationsLoading(true)
      const res = await getAllNotification()

      setNotificationsResponse(res)
    } finally {
      setGetNotificationsLoading(false)
    }
  }, [])

  const getNumberOfNotification = useCallback(async () => {
    try {
      setGetNotificationCountLoading(true)
      const res = await getNotificationCount()
      setGetNotificationCountResponse(res)
      setNotificationCount(res)
    } finally {
      setGetNotificationCountLoading(false)
    }
  }, [setNotificationCount])

  const update = useCallback(
    async (id: UpdateNotificationRequest) => {
      try {
        setUpdateNotificationLoading(true)
        const res = await updateNotification(id)
        setUpdateNotificationResponse(res)
        await getNumberOfNotification()
        await get()
      } finally {
        setUpdateNotificationLoading(false)
      }
    },
    [get, getNumberOfNotification]
  )

  return {
    getNotifications: get,
    updateNotification: update,
    getNumberOfNotification,
    getNotificationsResponse,
    getNotificationsLoading,
    updateNotificationResponse,
    updateNotificationLoading,
    getNotificationCountResponse,
    getNotificationCountLoading,
  }
}
